module.exports = __webpack_public_path__ + "img/ordMatrixyl1.854bc86d.jpg";